export const TRACKING_DEFAULT_PARAMS = {
  utm_campaign: 'parcelLab_OutForDelivery',
  utm_source: 'parcelLab',
  utm_medium: 'email',
  pwrdBy_parcelLab: 'hide',
  utm_content: 'trackandtrace',
}
